module.exports = __webpack_public_path__ + "img/dots_lbb3.9e93d595.png";